<div class="edit-product-modal">
  <div class="modal-header">
    <h2 class="modal-title">Edit Product</h2>
    <button type="button" class="close-button" (click)="onCancel()">
      <pdq-icon icon="close" size="medium"></pdq-icon>
    </button>
  </div>

  <div class="modal-content">
    <div class="product-preview">
      @if (data.product.imageUrl) {
        <img [src]="data.product.imageUrl" [alt]="originalName" class="product-image" />
      }
      <div class="product-info">
        <span class="product-name">{{ originalName }}</span>
        <span class="product-details">
          @if (data.product.sku) {
            <span>SKU: {{ data.product.sku }}</span>
          }
          @if (data.product.sku && data.product.price) {
            <span class="separator">•</span>
          }
          @if (data.product.price) {
            <span>{{ data.product.price }}</span>
          }
        </span>
      </div>
    </div>

    <div class="form-section">
      <div class="form-field">
        <label class="form-label">
          Override product name
          <span class="form-label__hint">(optional)</span>
        </label>
        <div class="input-with-clear">
          <pdq-input [(ngModel)]="displayName" [placeholder]="originalName"> </pdq-input>
          @if (displayName) {
            <pdq-icon icon="close" size="small" class="clear-icon" (click)="onClearName()"></pdq-icon>
          }
        </div>
        <span class="form-hint">Leave empty to use the original product name</span>
      </div>

      @if (showDescription) {
        <div class="form-field">
          <label class="form-label">
            Override product description
            <span class="form-label__hint">(optional)</span>
          </label>
          <div class="input-with-clear">
            <textarea
              class="description-textarea"
              [(ngModel)]="displayDescription"
              [placeholder]="originalDescription || 'Enter custom description...'"
              rows="3">
            </textarea>
            @if (displayDescription) {
              <pdq-icon icon="close" size="small" class="clear-icon" (click)="onClearDescription()"></pdq-icon>
            }
          </div>
          <span class="form-hint">Leave empty to use the original product description</span>
        </div>
      }
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn-secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn-primary" (click)="onSave()">Save</button>
  </div>
</div>
